// extracted by mini-css-extract-plugin
module.exports = {"disclosure":"styles_disclosure__LJggQ"};